import gql from "graphql-tag";

export const PURCHASE_MUTATION = gql`
  mutation Purchase($input: PurchaseInput!) {
    purchase(input: $input) {
      customerId
      transactionId
      discountValue
      promotionCode
    }
  }
`;
